import { track } from "@amplitude/analytics-react-native";
import { createStore } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import {
	EditCoverGalleryModalProps,
	EditCoverGallerySelection,
	EditCoverGalleryTabConfig,
} from "../types";

export interface EditCoverGalleryStore
	extends Pick<EditCoverGalleryModalProps, "configs" | "coverProfile"> {
	selection: EditCoverGallerySelection | null;
	selectCover: (selection: EditCoverGallerySelection) => void;
	onClose: () => void;
	selectedTab: EditCoverGalleryTabConfig | null;
	selectTab: (tab: EditCoverGalleryTabConfig) => void;
}

export const createEditCoverGalleryStore = (
	initialState: Pick<EditCoverGalleryStore, "configs" | "onClose"> &
		Partial<EditCoverGalleryStore>,
) => {
	return createStore<EditCoverGalleryStore>()(
		subscribeWithSelector((set, get) => ({
			...initialState,
			selectCover: (selection) => {
				set({ selection });
			},
			selection: initialState.selection ?? null,
			selectedTab: initialState.configs[0] ?? null,
			selectTab: (tab) => {
				track("editCover_tab_select", {
					variant: tab.variant,
				});
				set({ selectedTab: tab });
			},
		})),
	);
};
